import { Box, FormControlLabel } from '@mui/material';
import Typography from '@mui/material/Typography';
import bankPlaceHolder from 'assets/overviewSection/bankOfAmerica.png';
import Card from '@mui/material/Card';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import Container from '@mui/material/Container';
import { useEffect, useState } from 'react';
import { Banks } from 'lib/api';

async function selectNode(data) {
    const bankLinkData = await Banks.bankLinking({ identifier: data });
    return bankLinkData;
}

export const ApplyNewPayment = ({ setCounter, reduceCounter, nodesToList, selectedNode }) => {
    const [bankNode, setBankNode] = useState(false);
    const [nodeSelected, setNodeSelected] = useState('node');

    const handleChange = event => {
        setNodeSelected(event.target.value);
    };

    useEffect(() => {
        if (bankNode) {
            const ConfirmNode = async () => {
                const value = await selectNode(nodeSelected);
                if (!value.id) {
                    return alert('Unexpected error');
                }
                selectedNode(value);
                setCounter();
            };
            ConfirmNode();
            setBankNode(false);
        }
    }, [bankNode]);
    return (
        <Box
            style={{
                width: '450px',
                height: '549px'
            }}>
            <Card
                sx={{
                    background: 'linear-gradient(311deg, rgba(192,1,9,1) 0%, rgba(238,1,11,1) 50%, rgba(240,25,36,1) 100%);'
                }}>
                <CardContent>
                    <Container>
                        <Stack marginTop="1.5rem" alignItems="center">
                            <img src={bankPlaceHolder} width="60%" alt="Bank of america" />
                        </Stack>
                        <Box
                            marginTop="5rem"
                            sx={{
                                backgroundColor: '#ececec',
                                paddingX: '3.5rem',
                                paddingY: '1.5rem',
                                borderRadius: '1.5rem'
                            }}>
                            <Stack direction="row" justifyContent="center" alignItems="center">
                                <RadioGroup
                                    aria-label="bank"
                                    value={nodeSelected}
                                    onChange={handleChange}
                                    name="customized-radios">
                                    {nodesToList.map(node => (
                                        <>
                                            <FormControlLabel
                                                sx={{ marginBottom: '1.5rem' }}
                                                value={node.id}
                                                control={<Radio />}
                                                label={
                                                    <>
                                                        <Typography>
                                                            {node.name} {node.type} ({node.account_number})
                                                        </Typography>
                                                        <small>USD $ {node.balance}</small>
                                                    </>
                                                }
                                            />
                                        </>
                                    ))}
                                    <Stack></Stack>
                                </RadioGroup>
                            </Stack>
                            <Stack alignItems="center">
                                <Stack marginTop={6} direction="row" spacing={1}>
                                    <Button
                                        size="small"
                                        color="inherit"
                                        onClick={() => reduceCounter()}
                                        variant="contained"
                                        sx={{ marginRight: '.5rem' }}>
                                        <ArrowBackIosNewIcon></ArrowBackIosNewIcon>
                                    </Button>
                                    <Button size="small" color="inherit" onClick={() => setBankNode(true)} variant="contained">
                                        Select Fund
                                    </Button>
                                </Stack>
                            </Stack>
                        </Box>
                    </Container>
                </CardContent>
            </Card>
        </Box>
    );
};
